export const constants = {
  'Late installments': 'Cuotas atrasadas',
  'Next installment {{date}}': 'Proxima cuota {{date}}',
  Paid_installments: 'Pagadas',
};
